import Ajax from '../ajax';

export default {
  newsInfo: (newsId) => Ajax('get', `news/${newsId}`),
  newsList: (data) => Ajax('get', 'news', data),
  add: (data) => Ajax('post', 'news', data),
  edit: (data) => Ajax('put', `news/${data.newsId}`, data),
  delete: (newsId) => Ajax('delete', `news/${newsId}`),
};
